const NO = { id: 'no', name: 'No' };
const WPA = { id: 'wpa', name: 'WPA/WPA2/WPA3' };

export const WIFI_SECURITY_OPTIONS = {
  NO,
  WPA,
};
